// A screenshot of the restaurant's shop in the platform agent's panel (contracts §5 card shop_screenshot, §9).
export default {
  title: {
    phone: 'Je shop op een telefoon',
    desktop: 'Je shop op een computer',
  },
  loading: 'Screenshot laden',
  failed: 'Het screenshot kon niet worden geladen.',
};
